import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import * as _ from 'lodash';


export const isLookupOption = (lookup: Array<any>): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) { return null; }
    const option = _.find(lookup, (item) => {
      return item.option.toLowerCase() === control.value.toLowerCase();
    });
    return option ? null : {'notLookupOption': 'Not lookup option'};
  };
};
